import { instanceToPlain, plainToClass } from 'class-transformer';
var DiscussionCreateResponseDto = /** @class */ (function () {
    function DiscussionCreateResponseDto(args) {
        Object.assign(this, args);
    }
    DiscussionCreateResponseDto.fromJSON = function (data) {
        return plainToClass(DiscussionCreateResponseDto, data);
    };
    DiscussionCreateResponseDto.prototype.toJSON = function () {
        return instanceToPlain(this);
    };
    return DiscussionCreateResponseDto;
}());
export { DiscussionCreateResponseDto };
